__turbopack_context__.v({
  "accordionSlideOverwrite": "chip-module-scss-module__RrWqIa__accordionSlideOverwrite",
  "button": "chip-module-scss-module__RrWqIa__button",
  "chip": "chip-module-scss-module__RrWqIa__chip",
  "fadeIn": "chip-module-scss-module__RrWqIa__fadeIn",
  "fadeOut": "chip-module-scss-module__RrWqIa__fadeOut",
  "filled": "chip-module-scss-module__RrWqIa__filled",
  "medium": "chip-module-scss-module__RrWqIa__medium",
  "outlined": "chip-module-scss-module__RrWqIa__outlined",
  "scaleIn": "chip-module-scss-module__RrWqIa__scaleIn",
  "scaleOut": "chip-module-scss-module__RrWqIa__scaleOut",
  "small": "chip-module-scss-module__RrWqIa__small",
  "zoomIn": "chip-module-scss-module__RrWqIa__zoomIn",
  "zoomOut": "chip-module-scss-module__RrWqIa__zoomOut",
});
